import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LayoutStore {
  private readonly layoutMode = signal('horizontal');

  readonly mode = this.layoutMode.asReadonly();

  changeLayout(mode: string): void {
    this.layoutMode.set(mode);
  }
}
